export default __webpack_public_path__ + "static/media/landinglazy1.122ef305.jpg";